var map = {
	"./muviflex/icon-app.png": "./assets/icons/store/muviflex/icon-app.png",
	"./planalto/icon-app.png": "./assets/icons/store/planalto/icon-app.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/icons/store sync recursive ^\\.\\/.*\\/icon\\-app\\.png$";